import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { CUSTOM_ICONS } from '@app/core/constants/custom-icons.constant';
import { CustomIcon } from '@app/core/types/common/custom-icon.type';


export const customIconRegistryFactory =
  (iconRegistry: MatIconRegistry, domSanitizer: DomSanitizer): (() => void) =>
  (): void => {
    CUSTOM_ICONS.forEach(({ iconName, iconPath }: CustomIcon) =>
      iconRegistry.addSvgIcon(iconName, domSanitizer.bypassSecurityTrustResourceUrl(iconPath))
    );
  };
